module.exports = __webpack_public_path__ + "img/9.c20c4752.jpg";